
export class Stage {

    static DefaultStageName = '1e/Zb'

    name : string
    description? : string
    updatedAt?: number
    _rev?: string
}